import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskText, EASE } from "@/components/Reveal";
import { LIFESTYLE_BANNER } from "@/data/site";

export function LifestyleBanner() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[80vh] min-h-[520px] overflow-hidden" data-testid="lifestyle-banner">
      <motion.div style={{ y }} className="absolute inset-0 h-[130%]">
        <img src={LIFESTYLE_BANNER} alt="Noora lifestyle" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-ink/35" />

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        <MaskText
          animateOnLoad={false}
          lines={["Your Style.", "Your Shine.", "Your Noora."]}
          className="font-serif text-5xl font-light leading-[0.98] tracking-tight text-ivory sm:text-6xl md:text-8xl"
        />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.9, ease: EASE }}
        >
          <Link
            to="/shop"
            className="mt-10 inline-block rounded-full bg-ivory px-10 py-4 text-[0.72rem] uppercase tracking-[0.24em] text-ink transition-transform duration-300 hover:scale-[1.03] hover:bg-champagne"
            data-testid="lifestyle-shop"
          >
            Shop the Collection
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
